export default "__VITE_ASSET__B0q$v3lf__"